import React, { PureComponent } from "react";
import { ICSSProps, ColorProps, GlobalColorPalette, CardProps, ICSS, Color, Card } from "@gago/frame";
import styled from "styled-components";
import leftTop from "./images/tl.svg";
import rightTop from "./images/tr.svg";
import bottomRight from "./images/br.svg";
import bottomLeft from "./images/bl.svg";
import titleLeft from "./images/5.svg";
// tslint:disable:variable-name ter-max-len
// tslint:disable-next-line:completed-docs
const ScreenCardBody = styled.div<{colorPalette: GlobalColorPalette; noTitle?: string}>`
  height: 100%;
  width: 100%;
  position: relative;
  background-color: rgba(0, 8, 15, 0.55);
  border-top: 1px solid rgba(12, 212, 213, 0.15);
  border-bottom: 1px solid rgba(12, 212, 213, 0.15);
  padding: 15px 16px;
  .left-line{
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 1px;
    background-image: linear-gradient(to bottom, rgba(196, 250, 255, 0) 35%, rgba(20, 255, 212, 0.45) 50%, rgba(196, 235, 255, 0) 65%), linear-gradient(to bottom, rgba(196, 250, 255, 0), rgba(20, 255, 212, 0.45) 50%, rgba(196, 235, 255, 0));
    &::before{
      content: "";
      position: absolute;
      z-index: 3;
      top: 0;
      left: 0;
      height: 6px;
      width: 6px;
      background: url("${leftTop}") no-repeat;
      background-size: cover;
    }
    &::after{
      content: "";
      position: absolute;
      z-index: 3;
      left: 0;
      bottom: 0;
      height: 6px;
      width: 6px;
      background: url("${bottomLeft}") no-repeat;
      background-size: cover;
    }
  }
  .right-line{
    left: unset;
    right: 0;
    &::before{
      left: unset;
      right: 0;
      background-image: url("${rightTop}");
    }
    &::after{
      left: unset;
      right: 0;
      background-image: url("${bottomRight}");
    }
  }
  .header-title{
    height: 16px;
    line-height: 1;
    color: #c2fffa;
    font-size: 16px;
    font-weight: 500;
    padding-left: 25px;
    position: relative;
    &::before{
      content: "";
      position: absolute;
      z-index: 3;
      left: 0;
      top: 2px;
      height: 12px;
      width: 17px;
      background: url("${titleLeft}") no-repeat;
      background-size: contain;
    }
  }
  .screen-card-content{
    height: ${props => props.noTitle ? "calc(100% - 16px)" : "100%"};
    width: 100%;
    overflow: hidden;
    padding-top: ${props => props.noTitle ? "16px" : "0px"};
    position: relative;
  }
`;
type Sprops = {

} & ICSSProps & ColorProps<GlobalColorPalette> & CardProps;
/**
 * 增城大屏盒子
 * @author 马俊峰
 * @date 2020-07-23
 * @export
 * @class ScreenCard
 * @extends {PureComponent<Sprops>}
 * @implements {ICSS}
 * @implements {Color}
 * @implements {Card}
 */
export class ScreenCard extends PureComponent<Sprops> implements ICSS, Color, Card {
  render() {
    const { colorPalette, style, className, title, children } = this.props;
    return(
      <ScreenCardBody colorPalette={colorPalette} noTitle={title} style={style} className={className}>
        <div className="left-line" />
        <div className="left-line right-line" />
        {title && <div className="header-title">{title}</div>}
        <div className="screen-card-content">{children}</div>
      </ScreenCardBody>
    );
  }
}
